import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';

import { Card, Col, Row, Spinner } from 'react-bootstrap';


import FormularioFactura from './FormularioFactura';


const ListaFacturas = (
    {

        SetShowNuevaFactura,
        showNuevaFactura
    }

) => {


    const [facturas/*, setFacturas*/] = useState([]);
    const [cargando/*, setCargando*/] = useState(false);

    
   
    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {


    }, []);

    

    const datos = []

    //const columns = [
    //    {
    //        accessor: 'none',
    //        Header: 'ID',
    //        Cell: rowData => {
    //            const { idGasto } = rowData.row.original;
    //            return (
    //                <span
    //                    style={{
    //                        color: '#2c7be5', // Azul cielo
    //                        textDecoration: 'none', // Sin subrayado
    //                        cursor: 'pointer'
    //                    }}
    //                    onClick={() => {
    //                        setShowModalRegistrarGasto(true); // Mostrar el modal
    //                        setShowModalNuevo(false);
    //                    }}
    //                >
    //                    {idGasto}
    //                </span>
    //            );
    //        }
    //    },
    //    {
    //        accessor: 'vDescripcion',
    //        Header: 'Descripción',
    //        cellProps: { className: 'ps-1' },
    //        Cell: rowData => {
    //            const { vDescripcion } = rowData.row.original;
    //            return <span className=" text-dark">{vDescripcion}</span>; // Negritas y color oscuro
    //        }
    //    },
    //    {
    //        accessor: 'vResponsableName',
    //        Header: 'Responsable',
    //        cellProps: { className: 'ps-1' },
    //        Cell: rowData => {
    //            const { vResponsable } = rowData.row.original;
    //            return <span className="text-primary">{vResponsable}</span>; // Texto azul
    //        }
    //    },
    //    {
    //        accessor: 'dFechaGasto',
    //        Header: 'Fecha',
    //        cellProps: { className: 'ps-1' },
    //        Cell: rowData => {
    //            const { dFechaGasto } = rowData.row.original;

    //            // Formatear la fecha
    //            const formattedDate = new Date(dFechaGasto).toLocaleDateString("es-MX", {
    //                day: "2-digit",
    //                month: "short",
    //                year: "numeric"
    //            });

    //            // Transformar la primera letra del mes a mayúscula
    //            const formattedWithCapitalMonth = formattedDate.replace(
    //                /(?:^|\s)([a-z])/g,
    //                char => char.toUpperCase()
    //            );

    //            return <span className="text-secondary">{formattedWithCapitalMonth}</span>; // Texto gris
    //        }
    //    },
    //    {
    //        accessor: 'idTipoGasto',
    //        Header: 'Tipo de Gasto',
    //        cellProps: { className: 'ps-1' },
    //        Cell: rowData => {
    //            const { vTipoGasto } = rowData.row.original;
    //            return <span className="text-primary">{vTipoGasto}</span>; // Etiqueta estilizada
    //        }
    //    },
    //    {
    //        accessor: 'idCatFormaPago',
    //        Header: 'Forma de Pago',
    //        cellProps: { className: 'ps-1' },
    //        Cell: rowData => {
    //            const { vFormaPago } = rowData.row.original;
    //            return <span className="">{vFormaPago}</span>; 
    //        }
    //    },
    //    {
    //        accessor: 'dTotal',
    //        Header: 'Total',
    //        cellProps: { className: 'ps-1' },
    //        Cell: rowData => {
    //            const { dTotal } = rowData.row.original;
    //            return (
    //                <span className="">
    //                    {dTotal.toLocaleString("es-MX", { style: "currency", currency: "MXN" })}
    //                </span>
    //            );
    //        }
    //    }
    //];


    
    //console.log('showModalNuevaFactura:', showNuevaFactura);

    //console.log('Props en FormularioFactura:', {
    //    showNuevaFactura,
    //    setMensajeError,
    //    setShowMensajeError,
    //    setMensajeInformativo,
    //    setShowMensajeInformativo
    //});






    return (
        <>
         
            <Row>
                <Col>
                    <AdvanceTableWrapper
                        columns={datos}
                        data={facturas}
                        sortable
                        pagination
                        perPage={15}
                        
                    >

                       

                        <Card className="mb-3">
                            <Card.Header >

                                
                                
                                <Row>
                                    <Col className="ms-auto" sm={8} lg={4} xs={12} >
                                        {!cargando &&
                                            <AdvanceTableSearchBox table />
                                        }
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body className="p-0">

                                <AdvanceTable
                                    table
                                    headerClassName="bg-200 text-900 text-nowrap align-middle"
                                    rowClassName="align-middle white-space-nowrap"
                                    tableProps={{
                                        size: 'sm',
                                        striped: true,
                                        className: 'fs--2 mb-0 overflow-hidden'
                                    }}
                                />
                            </Card.Body>
                            <Card.Footer>
                                <AdvanceTableFooter
                                    rowCount={facturas.length}
                                    table
                                    rowInfo
                                    navButtons
                                    rowsPerPageSelection
                                />
                            </Card.Footer>
                        </Card>
                    </AdvanceTableWrapper>
                    {cargando && (<h5><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h5>)}
                </Col>     
            </Row>


            {
                showNuevaFactura &&
                <>
                    <FormularioFactura
                        SetShowNuevaFactura={SetShowNuevaFactura}
                        showNuevaFactura={showNuevaFactura}
                    />
                </>

            }

            
            


            


        </>
    );
};

ListaFacturas.propTypes = {
    showNuevaFactura: PropTypes.bool,
    SetShowNuevaFactura: PropTypes.func
};


export default ListaFacturas;